import type { IconData } from '@stacksjs/iconify-core'

export const noPhotoTakingZoneFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M2 1.5A1.5 1.5 0 0 0 .5 3v43A1.5 1.5 0 0 0 2 47.5h8.522a1.5 1.5 0 0 0 1.5-1.5v-4.901l2.923.505c2.642.457 5.031-1.5 5.248-4.136l.489-5.95c1.509-.461 2.658-1.07 3.473-1.61c1.628-1.08 1.63-3.114.773-4.414L20.99 19.52C20.261 9.474 12.068 1.5 2 1.5m30.25 22c-.482 0-.906.049-1.277.128c-1.698.362-2.236 1.952-2.287 2.981c-.071 1.449-.174 4.253-.185 8.514L26.8 36.45c-1.454 1.132-2.33 2.989-2 4.938c.363 2.15.917 3.87 1.494 5.208a1.5 1.5 0 0 0 1.377.905H44.26a1.5 1.5 0 0 0 1.429-1.042a33 33 0 0 0 1.226-5.203c.417-2.78-1.147-5.39-3.77-6.363c-1.883-.7-3.848-1.244-5.33-1.612a64 64 0 0 0-1.343-.318c-.07-1.825-.252-4.48-.367-6.075c-.093-1.282-.858-2.98-2.723-3.294a7 7 0 0 0-1.131-.093\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default noPhotoTakingZoneFlat
